import { render, staticRenderFns } from "./PbcPostPlay.vue?vue&type=template&id=d51d4888&"
import script from "./PbcPostPlay.vue?vue&type=script&lang=js&"
export * from "./PbcPostPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports